<div
  class="tw-relative tw-bg-white dark:tw-bg-gray-900 tw-rounded-xl tw-shadow-xl tw-max-w-5xl tw-mx-auto tw-overflow-hidden tw-border tw-border-gray-200 dark:tw-border-gray-700"
  [dir]="'auto'"
>
  <!-- Loading Spinner -->
  @if (processing()) {
  <div class="tw-absolute tw-inset-0 tw-bg-white/80 dark:tw-bg-gray-900/80 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-z-10">
    <div class="tw-flex tw-flex-col tw-items-start tw-space-y-3 sm:tw-space-y-4">
      <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 sm:tw-h-8 sm:tw-w-8 md:tw-h-12 md:tw-w-12 tw-border-b-2 tw-border-blue-600"></div>
      <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-font-medium tw-text-xs sm:tw-text-xs md:tw-text-base">{{ 'v2.invoicePlans.processing' | translate }}</p>
    </div>
  </div>
  }

  <!-- Loading State -->
  @if (!ready()) {
  <div class="tw-flex tw-items-center tw-justify-center tw-h-24 sm:tw-h-32 md:tw-h-48">
    <div class="tw-flex tw-flex-col tw-items-start tw-space-y-3 sm:tw-space-y-4">
      <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 sm:tw-h-8 sm:tw-w-8 md:tw-h-12 md:tw-w-12 tw-border-b-2 tw-border-blue-600"></div>
      <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-font-medium tw-text-xs sm:tw-text-xs md:tw-text-base">{{ 'v2.invoicePlans.loading' | translate }}</p>
    </div>
  </div>
  }

  <!-- Content -->
  @if (ready()) {
  <div class="tw-space-y-2 sm:tw-space-y-3">
    <!-- Header -->
    @if (createWorkspace) {
    <div class="tw-border tw-border-red-200 dark:tw-border-red-800 tw-rounded-lg tw-p-3 tw-mb-3">
      <div class="tw-flex tw-items-start tw-gap-2 tw-mb-2">
        <div class="tw-w-5 tw-h-5 tw-bg-red-500 tw-rounded-full tw-flex tw-items-center tw-justify-center">
          <i class="fas fa-exclamation-triangle tw-text-white tw-text-xs"></i>
        </div>
        <h6 class="tw-text-xs sm:tw-text-base tw-font-bold tw-text-red-700 dark:tw-text-red-400">
          {{ 'v2.invoicePlans.planLimited' | translate }}
        </h6>
      </div>
      <p class="tw-text-xs sm:tw-text-xs tw-text-gray-700 dark:tw-text-gray-300 tw-mb-1">
        {{ 'v2.invoicePlans.planLimitedDescription' | translate }}
      </p>
      <div class="tw-flex tw-items-start tw-gap-1">
        <i class="fas fa-arrow-up tw-text-blue-600 tw-text-xs"></i>
        <span class="tw-text-xs tw-font-medium tw-text-blue-600 dark:tw-text-blue-400">
          {{ 'v2.invoicePlans.upgradeToPro' | translate }}
        </span>
      </div>
    </div>
    }

    <!-- Comparison Table -->
    <div class="tw-bg-white dark:tw-bg-gray-800 tw-rounded-xl tw-shadow-lg tw-overflow-hidden tw-border tw-border-gray-200 dark:tw-border-gray-700">
      <!-- Table Header -->
      <div class="tw-bg-gray-50 dark:tw-bg-gray-700 tw-p-3 tw-border-b tw-border-gray-200 dark:tw-border-gray-600">
        <div class="tw-text-start">
          <p class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-md tw-font-inter">
            {{ 'v2.invoicePlans.comparePlans' | translate }}
          </p>
        </div>
      </div>

      <!-- Table Content -->
      <div class="tw-overflow-x-auto">
        <table class="tw-w-full tw-border-collapse">
          <!-- Table Header Row -->
          <thead>
            <tr class="tw-border-b-2 tw-border-gray-200 dark:tw-border-gray-600">
              <th class="tw-min-w-44 tw-px-3 tw-py-2 tw-text-start tw-font-bold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-base">
                <div class="tw-flex tw-items-start tw-gap-2">
                  {{ 'v2.invoicePlans.benefits' | translate }}
                </div>
              </th>
              <th
                class="tw-min-w-40 tw-px-3 tw-py-2 tw-text-start tw-font-bold tw-text-gray-700 dark:tw-text-gray-200 tw-bg-blue-50 dark:tw-bg-gray-800 tw-relative tw-border-l tw-border-gray-200 dark:tw-border-gray-600"
              >
                <div
                  class="tw-absolute tw-top-0 tw-end-0 tw-text-white dark:tw-text-gray-200 tw-text-xs tw-font-bold tw-px-2 tw-py-1 ltr:tw-rounded-bl-lg rtl:tw-rounded-br-lg tw-bg-blue-400 dark:tw-bg-blue-900"
                >
                  {{ 'v2.invoicePlans.currentPlan' | translate }}
                </div>
                <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
                  <div class="tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                    <i class="fas fa-check tw-text-gray-700 dark:tw-text-gray-200 tw-text-xs"></i>
                  </div>
                  <div>
                    <div class="tw-text-xs sm:tw-text-base tw-font-bold">{{ 'v2.invoicePlans.basic' | translate }}</div>
                    <div class="tw-text-lg tw-font-bold tw-text-gray-700 dark:tw-text-gray-200">({{ 'v2.invoicePlans.free' | translate }})</div>
                  </div>
                </div>
              </th>
              <th
                class="tw-px-3 tw-py-2 tw-text-start tw-font-bold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-border-l tw-border-gray-200 dark:tw-border-gray-600"
              >
                <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
                  <div class="tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                    <i class="fas fa-crown tw-text-gray-800 dark:tw-text-white tw-text-xs"></i>
                  </div>
                  <div>
                    <div class="tw-text-xs sm:tw-text-base tw-font-bold">{{ 'v2.invoicePlans.pro' | translate }}</div>
                    <div class="tw-text-xl tw-font-bold tw-text-gray-800 dark:tw-text-white">
                      @if (selectedPrice()) {
                      {{ (selectedPrice()?.unit_amount / 100).toFixed(2) | currency : selectedPrice()?.currency?.toUpperCase() : 'symbol-narrow' : '2.2-2' }}
                      }
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>

          <!-- Table Body -->
          <tbody>
            <!-- Duration Selection Row (Pro Plan Only) -->
            @if (proPlan()?.productPrice) {
            <tr class="tw-border-b tw-border-gray-200 dark:tw-border-gray-600 tw-hover:tw-bg-gray-50 dark:tw-hover:tw-bg-gray-700/50 tw-transition-colors tw-duration-200">
              <td class="tw-px-3 tw-py-2 tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-xs">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <i class="fas fa-calendar-alt tw-text-purple-500 tw-text-xs"></i>
                  {{ 'v2.invoicePlans.billingCycle' | translate }}
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-blue-50 dark:tw-bg-gray-800">
                <span class="tw-text-xs tw-text-gray-700 dark:tw-text-gray-200">-</span>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700">
                <div class="">
                  <div class="tw-flex tw-justify-start tw-gap-1">
                    @for (price of proPlan()?.productPrice; track price.id) {
                    <button
                      (click)="updateSelectedPrice(price)"
                      [class]="
                        'tw-px-3 tw-py-2 tw-w-flex tw-flex-1 tw-rounded-md tw-font-semibold tw-transition-all tw-duration-200 tw-text-xs tw-min-w-16 tw-shadow-sm tw-transform hover:tw-scale-105 tw-border-2 ' +
                        (selectedPrice()?.id === price.id
                          ? 'tw-text-blue-500 tw-bg-blue-50 tw-border-blue-500 dark:tw-bg-blue-900/20 '
                          : 'tw-bg-white dark:tw-bg-gray-800 tw-text-gray-600 dark:tw-text-gray-300 tw-border-gray-300 dark:tw-border-gray-600 hover:tw-bg-white dark:hover:tw-bg-blue-800/40 hover:tw-border-blue-500 dark:hover:tw-border-blue-500 hover:tw-text-gray-900 dark:hover:tw-text-white hover:tw-shadow-md')
                      "
                    >
                      {{ getIntervalText(price) }}
                    </button>
                    }
                  </div>
                </div>
                <div class="tw-pt-2 tw-rounded-lg">
                  <button
                    (click)="initiateUpgrade()"
                    [disabled]="processing()"
                    class="tw-w-full tw-text-white hover:tw-text-white dark:hover:tw-text-gray-300 tw-bg-blue-500 hover:tw-bg-blue-600 tw-font-bold tw-py-2 tw-px-3 tw-rounded-lg tw-transition-all tw-duration-200 tw-text-xs tw-shadow-lg hover:tw-shadow-xl tw-transform hover:tw-scale-105"
                  >
                    @if (processing()) {
                    <div class="tw-flex tw-items-center tw-justify-start tw-gap-1">
                      <div class="tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-b-2 tw-border-gray-500 dark:tw-border-gray-400"></div>
                      <span>{{ 'v2.invoicePlans.processing' | translate }}</span>
                    </div>
                    } @else {
                    <div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                      <i class="fas fa-arrow-up tw-text-xs"></i>
                      {{ 'v2.invoicePlans.switchToPro' | translate }}
                    </div>
                    }
                  </button>
                </div>
              </td>
            </tr>
            }

            <!-- Features Comparison Rows -->
            @if (basicPlan() && proPlan()) {
            <!-- Single Workspace vs Unlimited Workspaces -->
            <tr class="tw-border-b tw-border-gray-200 dark:tw-border-gray-600 tw-hover:tw-bg-gray-50 dark:tw-hover:tw-bg-gray-700/50 tw-transition-colors tw-duration-200">
              <td class="tw-px-3 tw-py-2 tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-xs">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <i class="fas fa-building tw-text-indigo-500 tw-text-xs"></i>
                  {{ 'v2.invoicePlans.workspaces' | translate }}
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-blue-50 dark:tw-bg-gray-800">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-text-xs tw-font-medium tw-text-gray-700 dark:tw-text-gray-200">{{ 'v2.invoicePlans.singleWorkspace' | translate }}</span>
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <div class="tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                    <i class="fas fa-arrow-up tw-text-gray-800 dark:tw-text-white tw-text-xs"></i>
                  </div>
                  <span class="tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-text-white">{{ 'v2.invoicePlans.unlimitedWorkspaces' | translate }}</span>
                </div>
              </td>
            </tr>

            <!-- Users -->
            <tr class="tw-border-b tw-border-gray-200 dark:tw-border-gray-600 tw-hover:tw-bg-gray-50 dark:tw-hover:tw-bg-gray-700/50 tw-transition-colors tw-duration-200">
              <td class="tw-px-3 tw-py-2 tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-xs">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <i class="fas fa-users tw-text-emerald-500 tw-text-xs"></i>
                  {{ 'v2.invoicePlans.users' | translate }}
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-blue-50 dark:tw-bg-gray-800">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-text-xs tw-font-medium tw-text-gray-700 dark:tw-text-gray-200">{{ 'v2.invoicePlans.unlimited' | translate }}</span>
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-ms-7 tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-text-white">{{ 'v2.invoicePlans.unlimited' | translate }}</span>
                </div>
              </td>
            </tr>

            <!-- Dashboard Updates -->
            <tr class="tw-border-b tw-border-gray-200 dark:tw-border-gray-600 tw-hover:tw-bg-gray-50 dark:tw-hover:tw-bg-gray-700/50 tw-transition-colors tw-duration-200">
              <td class="tw-px-3 tw-py-2 tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-xs">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <i class="fas fa-chart-line tw-text-orange-500 tw-text-xs"></i>
                  {{ 'v2.invoicePlans.dashboardUpdates' | translate }}
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-blue-50 dark:tw-bg-gray-800">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-text-xs tw-font-medium tw-text-gray-700 dark:tw-text-gray-200">{{ 'v2.invoicePlans.every2Minutes' | translate }}</span>
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <div class="tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                    <i class="fas fa-arrow-up tw-text-gray-800 dark:tw-text-white tw-text-xs"></i>
                  </div>
                  <span class="tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-text-white">{{ 'v2.invoicePlans.realtime' | translate }}</span>
                </div>
              </td>
            </tr>

            <!-- Free Exports -->
            <tr class="tw-border-b tw-border-gray-200 dark:tw-border-gray-600 tw-hover:tw-bg-gray-50 dark:tw-hover:tw-bg-gray-700/50 tw-transition-colors tw-duration-200">
              <td class="tw-px-3 tw-py-2 tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-xs">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <i class="fas fa-download tw-text-cyan-500 tw-text-xs"></i>
                  {{ 'v2.invoicePlans.freeExports' | translate }}
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-blue-50 dark:tw-bg-gray-800">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-text-xs tw-font-medium tw-text-gray-700 dark:tw-text-gray-200"
                    >{{ basicPlan()?.free_exported_entries }} {{ 'v2.invoicePlans.registrants' | translate }}</span
                  >
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <div class="tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                    <i class="fas fa-arrow-up tw-text-gray-800 dark:tw-text-white tw-text-xs"></i>
                  </div>
                  <span class="tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-text-white"
                    >{{ proPlan()?.free_exported_entries }} {{ 'v2.invoicePlans.registrants' | translate }}</span
                  >
                </div>
              </td>
            </tr>

            <!-- Virtual Registrant Price -->
            <tr class="tw-border-b tw-border-gray-200 dark:tw-border-gray-600 tw-hover:tw-bg-gray-50 dark:tw-hover:tw-bg-gray-700/50 tw-transition-colors tw-duration-200">
              <td class="tw-px-3 tw-py-2 tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-xs">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <i class="fas fa-video tw-text-pink-500 tw-text-xs"></i>
                  {{ 'v2.invoicePlans.perVirtual' | translate }}
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-blue-50 dark:tw-bg-gray-800">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-text-xs tw-font-medium tw-text-gray-700 dark:tw-text-gray-200">
                    {{ (basicPlan()?.virtualPrice.unit_amount / 100).toFixed(2) | currency : selectedPrice()?.currency?.toUpperCase() : 'symbol-narrow' : '1.2-2' }}
                  </span>
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-ms-7 tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-text-white">
                    {{ (proPlan()?.virtualPrice.unit_amount / 100).toFixed(2) | currency : selectedPrice()?.currency?.toUpperCase() : 'symbol-narrow' : '1.2-2' }}
                  </span>
                </div>
              </td>
            </tr>

            <!-- In-Person Registrant Price -->
            <tr class="tw-hover:tw-bg-gray-50 dark:tw-hover:tw-bg-gray-700/50 tw-transition-colors tw-duration-200">
              <td class="tw-px-3 tw-py-2 tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-bg-gray-50 dark:tw-bg-gray-700 tw-text-xs sm:tw-text-xs">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <i class="fas fa-user-friends tw-text-teal-500 tw-text-xs"></i>
                  {{ 'v2.invoicePlans.perInPerson' | translate }}
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-blue-50 dark:tw-bg-gray-800">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <span class="tw-text-xs tw-font-medium tw-text-gray-700 dark:tw-text-gray-200">
                    {{ (basicPlan()?.defaultPrice.unit_amount / 100).toFixed(2) | currency : selectedPrice()?.currency?.toUpperCase() : 'symbol-narrow' : '1.2-2' }}
                  </span>
                </div>
              </td>
              <td class="tw-px-3 tw-py-2 tw-text-start tw-border-l tw-border-gray-200 dark:tw-border-gray-600 tw-bg-gray-50 dark:tw-bg-gray-700">
                <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
                  <div class="tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                    <i class="fas fa-arrow-up tw-text-gray-800 dark:tw-text-white tw-text-xs"></i>
                  </div>
                  <span class="tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-text-white">
                    {{ (proPlan()?.defaultPrice.unit_amount / 100).toFixed(2) | currency : selectedPrice()?.currency?.toUpperCase() : 'symbol-narrow' : '1.2-2' }}
                  </span>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  }
</div>
